<template>
  <div class="marathon-activate">
    <p-button
      :disabled="marathon.isDisabled"
      type="info"
      @click="() => activateMarathon({ type: 'marathonActivation' })">
      <el-icon v-if="marathon.isDisabled" class="is-loading">
        <Loading/>
      </el-icon>
      <span v-else>Активировать</span>
    </p-button>
    <div v-if="!!marathon.countTasks" class="marathon-footer">
      <p class="count-tasks-marathon">
        Количество задач в марафоне:
      </p>
      <div class="marathon-count">
        <i v-if="marathon.isDisabled" class="el-icon-loading"/>
        <span v-else>
          {{ marathon.countTasks }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "MarathonActivationCard",
  props: {
    countTasks: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters({
      marathon: 'superadministrator/marathonActivation'
    })
  },
  methods: {
    ...mapActions({
      activateMarathon: 'superadministrator/activateMarathon',
      clearMarathonCount: 'superadministrator/clearMarathonCount'
    }),
  },
  beforeUnmount() {
    this.clearMarathonCount()
  }
}
</script>

<style scoped>

</style>
